export const getOauthLink = (provider: string) =>
  `${process.env.HTTP_PROTOCOL}://app.${process.env.ROOT_NETLOC}/oauth/login/${provider}`;
